// extracted by mini-css-extract-plugin
module.exports = {"section":"paid-objective_section__1qIfE","continaer":"paid-objective_continaer__u5UE8","textbox":"paid-objective_textbox__ClzLY","image":"paid-objective_image__Ju_Fw"};